export const PORT = 8080;

export const daysOfWeek = [
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday",
];

export const onlinePaymentMode = [
  { key: "payfast", label: "Pay Fast" },
  { key: "stripe", label: "Stripe" },
];

export const paymentModesConfig = {
  stripe: [
    {
      name: "secretKey",
      label: "Stripe Secret Key",
      placeholder: "Stripe Secret Key",
      message: "Secret Key is required.",
    },
    {
      name: "publishableKey",
      label: "Stripe Publishable Key",
      placeholder: "Stripe Publishable Key",
      message: "Publish Key is required.",
    },
  ],
  payfast: [
    {
      name: "merchantId",
      label: "Payfast Merchant Id",
      placeholder: "Payfast Merchant Id",
      message: "Payfast Merchant Id Key is required.",
    },
    {
      name: "securedKey",
      label: "Payfast Secured Key",
      placeholder: "Payfast Secured Key",
      message: "Payfast Secured Key is required.",
    },
  ],
};

export const APPSTATUS = {
  INITIALIZED: "initialized",
  PENDING_CONFIRMATION: "pending-confirmation",
  CONFIRMED: "confirmed",
  IN_DELIVERY: "in-delivery",
  ARRIVED: "arrived",
  COMPLETED: "completed",
  CUSTOMER_CANCELLED: "customer-cancelled",
  RESTAURANT_CANCELLED: "restaurant-cancelled",
  CANCELLED: "cancelled",
  ADMIN_CANCELLED: "admin-cancelled",
  SERVER_ERROR: "server-error",
};

export const allCancelledStatus = [
  APPSTATUS.CANCELLED,
  APPSTATUS.ADMIN_CANCELLED,
  APPSTATUS.RESTAURANT_CANCELLED,
  APPSTATUS.CUSTOMER_CANCELLED,
];

export const appType = {
  SIGLE: "single",
};

export const currenciesJSON = [
  { label: "Pakistan", value: "Rs" },
  { label: "USA", value: "$" },
  { label: "Australia", value: "AU$" },
];

export const prevOrder = ["completed", ...allCancelledStatus];

export const DriverPaymentType = {
  COMMISSION: "commission",
  SALARY: "salary",
};

export const TransactionTypes = {
  EXPENSE: "expense",
  RIDER_TRANSACTION: "rider-transaction",
  POS_ORDER: "pos-order",
  POS_ORDER_CANCELLATION: "pos-order-cancellation",
  DELIVERY_ORDER: "delivery-order",
  PICKUP_ORDER: "pickup-order",
  SALARY: "salary",
  BALANCE_CLEAR: "balance-clear",
  ORDER_CANCELLATION: "order-cancellation",
  TOPUP: "top-up",
};

//for orders (new backend architecture)
export const OrderStatus = {
  PENDING: "pending",
  CONFIRMED: "confirmed",
  PREPARED: "prepared",
  IN_DELIVERY: "in_delivery",
  CANCELLED: "cancelled",
  COMPLETED: "completed",
};

export const OrderStatusUI = {
  [OrderStatus.PENDING]: {
    label: "Pending",
    color: "#faad14",
  },
  [OrderStatus.CONFIRMED]: {
    label: "Confirmed",
    color: "#1890ff",
  },
  [OrderStatus.PREPARED]: {
    label: "Prepared",
    color: "#73d13d",
  },
  [OrderStatus.IN_DELIVERY]: {
    label: "In Delivery",
    color: "#4096ff",
  },
  [OrderStatus.CANCELLED]: {
    label: "Cancelled",
    color: "#ff4d4f",
  },
  [OrderStatus.COMPLETED]: {
    label: "Completed",
    color: "#595959",
  },
};

export const PREVIEW_ONLY_STATUSES = [
  OrderStatus.COMPLETED,
  OrderStatus.CANCELLED,
];

export const TAB_TO_STATUS_MAP = {
  pending: OrderStatus.PENDING,
  confirmed: OrderStatus.CONFIRMED,
  prepared: OrderStatus.PREPARED,
  in_delivery: OrderStatus.IN_DELIVERY,
  completed: OrderStatus.COMPLETED,
  cancelled: OrderStatus.CANCELLED,
};

export const ordersTab = Object.keys(TAB_TO_STATUS_MAP);

export const roles = [
  { label: "Admin", value: "shop-admin" },
  { label: "Super Admin", value: "shop-owner" },
  { label: "Chef", value: "shop-chef" },
  { label: "POS Operator", value: "shop-pos-operator" },
  { label: "Waiter", value: "shop-waiter" },
];

export const Services = [
  {
    label: "POS",
    value: "pos",
  },
  {
    label: "Whatsapp Ordering",
    value: "whatsapp-ordering",
  },
  {
    label: "Website Ordering",
    value: "website-ordering",
  },
  {
    label: "Mobile App Ordering",
    value: "mobile-app-ordering",
  },
  {
    label: "Rider App",
    value: "rider-app",
  },
];

export const BULK_ITEMS_TEMPLATE =
  "https://pub-f0af42bedbc349759c9d1e9944e08a97.r2.dev/bulkupload_template_1787301407076.xlsx";

export const InventoryItemUnit = {
  KG: "kg",
  G: "g",
  L: "l",
  PCS: "pcs",
  ML: "ml",
  BOTTLE: "bottle",
  BOX: "box",
  PACKET: "packet",
};

export const InventoryItemUnitOptions = [
  { label: "Kilogram (kg)", value: InventoryItemUnit.KG },
  { label: "Gram (g)", value: InventoryItemUnit.G },
  { label: "Liter (l)", value: InventoryItemUnit.L },
  { label: "Pieces (pcs)", value: InventoryItemUnit.PCS },
  { label: "Milliliter (ml)", value: InventoryItemUnit.ML },
  { label: "Bottle", value: InventoryItemUnit.BOTTLE },
  { label: "Box", value: InventoryItemUnit.BOX },
  { label: "Packet", value: InventoryItemUnit.PACKET },
];
